import * as React from "react";
import { Modal } from "./Modal";
import { Button } from "./Button";
import { MarkdownBody } from "../scene/MarkdownBody";
import type { PromoModalContent } from "../../api/content";

type Props = {
  promo: PromoModalContent | null;
  open: boolean;
  onClose: () => void;
  /** Portal host so the overlay escapes drei's <Scroll html> transform. */
  portalHost?: HTMLElement | null;
};

export function PromoModal({ promo, open, onClose, portalHost }: Props) {
  if (!promo) return null;
  const hasButton = promo.buttonLabel.trim().length > 0;
  const hasLink = hasButton && promo.buttonUrl.trim().length > 0;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={promo.title}
      container={portalHost}
      footer={
        hasButton ? (
          hasLink ? (
            <Button variant="solid" as="a" href={promo.buttonUrl} fluid>
              {promo.buttonLabel}
            </Button>
          ) : (
            <Button variant="solid" onClick={onClose} fluid>
              {promo.buttonLabel}
            </Button>
          )
        ) : undefined
      }
      footerLayout="full"
    >
      {promo.image ? (
        <img
          src={promo.image}
          alt=""
          className="mb-5 w-full rounded-xl object-cover"
        />
      ) : null}
      {promo.body ? <MarkdownBody surface="light" body={promo.body} /> : null}
    </Modal>
  );
}
